<!-- 创建时间2023/06/20 10:45:06 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述：表单-游客 -->
<template>
  <div v-if="config">
    <yxt-checkbox
      v-model="config.visitorEnabled"
      :true-label="1"
      :false-label="0"
      :disabled="disabled">
      {{ $t('pc_kng_upload_label_support_visitor'/** 支持游客访问 */) }}
    </yxt-checkbox>
    <yxt-button v-if="config.visitorEnabled" class="ml4" type="text" :disabled="disabled" @click="set">{{ $t('pc_kng_upload_lbl_visitor_collect'/** 游客信息收集项 */) }}</yxt-button>
    <div v-if="config.visitorEnabled">
      <yxt-radio-group class="ml24" direction="row" v-model="config.authType" :disabled="disabled">
        <yxt-radio :label="1">{{ $t('pc_kng_upload_label_wx_login_visitor'/** 游客需微信授权后观看 */) }}</yxt-radio>
        <yxt-radio :label="2">{{ $t('pc_kng_upload_label_mb_login_visitor'/** 游客需手机号+验证码验证后观看 */) }}</yxt-radio>
      </yxt-radio-group>
      <div>
        <yxt-checkbox
          v-model="config.encryptEnabled"
          :true-label="1"
          :false-label="0"
          :disabled="disabled">
          {{ $t('pc_kng_upload_label_encrypt_pwd_visitor'/** 加密观看（加密后游客需要输入密码才可观看） */) }}
        </yxt-checkbox>
      </div>
      <div class="ml24 mt8">
        <yxt-input
          v-if="config.encryptEnabled"
          v-model="config.encryptPwd"
          maxlength="6"
          :placeholder="$t('pc_biz_lbl_setsixnumberpwd'/** 请设置6位数字密码 */)"
          :disabled="disabled"
        ></yxt-input>
      </div>
    </div>
    <yxtbiz-msg-collector-v2 :default-data="defaultData" @select="confirm" :visible.sync="visible" />
  </div>
</template>

<script>
import { getKngDetailOfVisitor } from 'yxt-biz-pc/packages/kng-operator/service';
export default {
  name: 'form-visitor',
  inject: ['getIsEdit', 'getInfo'],
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false
    };
  },
  computed: {
    isEdit() {
      return this.getIsEdit();
    },
    info() {
      return this.getInfo();
    },
    defaultData() {
      return {
        required: (this.config.requiredInfo || '').split(','),
        optional: (this.config.optionalInfo || '').split(',')
      };
    }
  },
  watch: {
    'config.encryptPwd'(val) {
      if (val && /[^\d]/g.test(val)) {
        this.config.encryptPwd = this.config.encryptPwd.replace(/[^\d]/g, '');
      }
    },
    'config.visitorEnabled'(val) {
      if (!this.config.authType && val) this.$set(this.config, 'authType', 1);
    }
  },
  created() {
    if (this.isEdit) {
      this.setConfig();
    }
  },
  methods: {
    setConfig() {
      getKngDetailOfVisitor(this.info.id)
        .then(res => {
          Object.keys(res).forEach(key => {
            this.$set(this.config, key, res[key]);
          });
          this.$emit('update:config', this.config);
        });
    },
    set() {
      this.visible = true;
    },
    confirm(res) {
      const optional = res.optional || [];
      const required = res.required || [];
      this.$set(this.config, 'requiredInfo', required.join(','));
      this.$set(this.config, 'optionalInfo', optional.join(','));
    }
  }
};
</script>